// F-95b pre-order sizes (DRAFT, review duplicate only). Generated by preorder/storefront.mjs; do not edit here.
(() => {
  if (window.elmsettPreorderSizes) return;
  window.elmsettPreorderSizes = true;
  // F-101a: Halcyon's made-to-order arrival date is today in Sydney + data-es-po-days, so a page served from Shopify's
  // page cache after midnight still shows the date a buyer ordering now would get (the server writes the same date)
  const dates = (root = document) => {
    const els = root.querySelectorAll('[data-es-po-days]');
    if (!els.length) return;
    const p = Object.fromEntries(new Intl.DateTimeFormat('en-AU', { timeZone: 'Australia/Sydney', year: 'numeric', month: 'numeric', day: 'numeric' }).formatToParts(new Date()).map((x) => [x.type, x.value]));
    const out = new Intl.DateTimeFormat('en-GB', { timeZone: 'UTC', day: 'numeric', month: 'long' });
    els.forEach((el) => {
      const text = out.format(new Date(Date.UTC(Number(p.year), Number(p.month) - 1, Number(p.day) + Number(el.dataset.esPoDays))));
      if (el.textContent !== text) el.textContent = text;
    });
  };
  dates();
  const refresh = ({ data } = {}) => {
    const html = data?.html;
    const id = data?.sectionId;
    if (!html || !id) return;
    for (const region of ['EsPreorderLine', 'EsPreorderTerms', 'EsPreorderDelivery', 'EsRestock', 'EsShipNote']) {
      const next = html.getElementById(`${region}-${id}`);
      const here = document.getElementById(`${region}-${id}`);
      if (next && here) here.innerHTML = next.innerHTML;
    }
    dates();
    const form = document.getElementById(`product-form-${id}`);
    const nextForm = html.getElementById(`product-form-${id}`);
    if (!form || !nextForm) return;
    // a postcode answer given for the size chosen before never stays next to another size
    form.closest('product-info')?.querySelectorAll('.es-delivery-estimate__result').forEach((r) => { r.hidden = true; });
    for (const sel of ['input[data-es-po-plan]', 'input[data-es-po-prop]', 'input[data-es-po-ship]']) {
      const here = form.querySelector(sel);
      const next = nextForm.querySelector(sel);
      if (here && next) {
        here.value = next.value;
        here.disabled = next.disabled;
      }
    }
    const buttons = form.querySelector('.product-form__buttons');
    const nextButtons = nextForm.querySelector('.product-form__buttons');
    if (buttons && nextButtons) buttons.classList.toggle('es-po-selected', nextButtons.classList.contains('es-po-selected'));
    const button = document.getElementById(`ProductSubmitButton-${id}`);
    const nextButton = html.getElementById(`ProductSubmitButton-${id}`);
    if (!button || !nextButton) return;
    for (const name of ['button--primary', 'button--secondary']) button.classList.toggle(name, nextButton.classList.contains(name));
    const label = nextButton.dataset.esAddLabel;
    if (!label) return;
    const sticky = document.getElementById(`EsStickyBuy-${id}`);
    if (sticky) sticky.dataset.addLabel = label;
    button.dataset.esAddLabel = label;
    const text = button.querySelector('span');
    if (text && !button.disabled) text.textContent = label;
  };
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.variantChange, refresh);
  // F-95e (Owner 2026-10-09: a made-to-order size has no pickup and no Australian warehouse; it goes from the factory to
  // the door): while a made-to-order size is chosen, the Delivery tab's postcode check answers with the made-to-order
  // line under the price, never the in-stock transit time from the warehouse. Runs before elmsett.js's own handler.
  document.addEventListener('submit', (event) => {
    const box = event.target;
    if (!(box instanceof HTMLFormElement) || !box.matches('.es-delivery-estimate__form')) return;
    const info = box.closest('product-info');
    // F-95n: an overseas-stock size answers with its own delivery line too
    const prop = info?.querySelector('input[data-es-po-prop]:not([disabled])') || info?.querySelector('input[data-es-po-ship]:not([disabled])');
    const made = prop ? info.querySelector('.es-preorder-made')?.textContent.trim() : '';
    if (!made) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const input = box.querySelector('input');
    const result = box.parentElement?.querySelector('.es-delivery-estimate__result');
    if (!input || !result) return;
    input.setCustomValidity(/^\d{4}$/.test(input.value.trim()) ? '' : 'Please enter a 4-digit postcode.');
    if (!input.reportValidity()) return;
    result.hidden = false;
    result.textContent = made;
  }, true);
})();
